import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { fmt, round2 } from "../lib/calc";
import { buildBidUrl, showSendQuote } from "../lib/handoff";

export const SendQuoteButton = ({ haulId, r, template }) => {
  const [busy, setBusy] = useState(false);
  if (!showSendQuote(haulId, r.recommendedQuote, template)) return null;
  const quote = round2(r.recommendedQuote);
  const ready = r.status !== null && r.profit !== null;

  const send = async () => {
    setBusy(true);
    try {
      await api.post("/results", {
        label: `Haul ${haulId}`,
        true_trip_cost: round2(r.trueCost),
        recommended_quote: quote,
        projected_profit: round2(r.profit),
        status: r.status,
      });
      window.location.assign(buildBidUrl(template, haulId, quote));
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };

  return (
    <div className="send-quote" data-testid="send-quote-box">
      <button type="button" className="btn send" data-testid="btn-send-quote-brv" disabled={!ready || busy} onClick={send}>
        <Send size={18} /> {busy ? "Sending…" : `Send ${fmt.money(quote)} quote to Boat RV Moving`}
      </button>
      <p className="save-note" data-testid="send-quote-note">
        {ready ? `Saves to History as "Haul ${haulId}" and opens the bid form. Only the haul ID and quote are sent.` : "Enter the customer offer and loaded miles to send this quote."}
      </p>
    </div>
  );
};
